/*****************************************************/
/* 処　理：SMS008 請求金額詳細 画面
/*
/* 概　要：INパラメータ
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SMS008KingakuInfoInVO {

  /** 画面ID */
  screenId!: string;

  /** 家賃年月 */
  yatinYm!: string;

}
